import {
    broadcast,
    onBroadcast,
} from "../api"
import App from './App'
let nativeComponentMap = {}
document.addEventListener('nativeComponentCreated', function(event){
    const { id, instance } = event.param
    nativeComponentMap[id] = instance
})



const Message =  {
    broadcast,
    onBroadcast,
    //收到父视图发来的消息
    onWebviewPostMessage(cb) {
        onBroadcast('webviewPostMessage', (event)=>{
            console.log('收到postmessage', event, App, App.rootWebview)
            const { data={} } = event
            if(data.id === App.rootWebview.id){
                cb && cb(data.data)
            }
        })
    },
    //收到子视图向父视图发来的消息
    onEmitMessage(eventName, cb) {
        onBroadcast('webviewEmitMessage', (event)=>{
            // console.log('收到EmitMessage',event,nativeComponentMap,nativeComponentMap[event.data.id],eventName,event.data.eventName)
            const { data={} } = event
            if(nativeComponentMap[data.id] && data.id!==App.rootWebviewId && eventName===data.eventName){
                console.warn('收到指定的 ==》 EmitMessage', event,nativeComponentMap,nativeComponentMap[data.id],eventName,data.eventName)
                cb && cb(data.data)
            }
        })
    },
    //向父视图发送消息
    emitMessage(eventName, params={}) {
        const _params = {
            id: App.rootWebview.id,
            eventName,
            data: {
                ...params
            }
        }
        return broadcast('webviewEmitMessage', _params)
    }
}

export default Message